import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs } from "@air/primitive-tabs";
import { memo } from "react";
import { PRIVATE_CONTENT_SHARE_TABS } from "~/constants/testIDs";
export const SharePrivateContentTabs = /*#__PURE__*/ memo((param)=>{
    let { panels, setActiveTab, activeTab } = param;
    return /*#__PURE__*/ _jsx(Tabs, {
        className: "-mx-6 -mt-1",
        defaultValue: "link",
        listClassName: "px-6",
        panels: panels,
        panelsClassName: "px-8 pt-4",
        onValueChange: setActiveTab,
        value: activeTab,
        "data-testid": PRIVATE_CONTENT_SHARE_TABS
    });
});
SharePrivateContentTabs.displayName = "SharePrivateContentTabs";
